// extracted by mini-css-extract-plugin
export var listOrderDetails = "styles_listOrderDetails__ZJ8nS";
export var product = "styles_product__Qsb2r";
export var productText = "styles_productText__4pGaY";
export var surprise = "styles_surprise__AvSqv";